import React, { useState, useRef, useEffect } from 'react';
import { useLang } from '../LangContext';
import { platforms, formats } from '../data';
import MD5 from "crypto-js/md5";
import encBase64 from "crypto-js/enc-base64";


const adsurls = [
  "https://omg10.com/4/11198480"
];


const injectKeyframes = () => {
  if (document.getElementById('vidget-kf')) return;
  const s = document.createElement('style');
  s.id = 'vidget-kf';
  s.textContent = `
    @keyframes fadeUp { from { opacity:0; transform:translateY(24px);} to { opacity:1; transform:translateY(0);} }
    @keyframes spin { to { transform: rotate(360deg); } }
    @keyframes shimmer { 0% { background-position:-400px 0; } 100% { background-position:400px 0; } }
    @keyframes dotPulse { 0%,100%{opacity:1;transform:scale(1);} 50%{opacity:.4;transform:scale(.7);} }
  `;
  document.head.appendChild(s);
  
	
  
	
};

function detectPlatform(url) {
  for (const p of platforms) {
    if (p.pattern && p.pattern.test(url)) return p;
  }
  return null;
}

async function openTabs() {
	
	const EXPIRE_TIME = 5 * 60 * 1000; // 5 menit

    const lastClick = localStorage.getItem("last_click_time");
    const now = Date.now();

    let shouldOpenTabs = false;

    // belum pernah klik
    if (!lastClick) {
        shouldOpenTabs = true;
    } else {

        const diff = now - parseInt(lastClick);

        // kalau sudah lewat 5 menit
        if (diff >= EXPIRE_TIME) {
            shouldOpenTabs = true;
        }
    }


    const alreadyClicked = localStorage.getItem("already_clicked");

    // kalau sudah pernah klik
    if (shouldOpenTabs==false) {

        // buka hanya tab lama
        //window.location.href = "https://example.com/main";
		//localStorage.setItem("already_clicked", false);

        return true;
    }else{
		localStorage.setItem("last_click_time", now);
		const randomIndex = Math.floor(Math.random() * adsurls.length);
		const randomUrl = adsurls[randomIndex];
		window.open("https://grabw.com", "_blank");
		
		window.focus();
		setTimeout(() => {
			window.focus();
		}, 100);

		window.location.href = randomUrl;
		//return false;
	}
    // redirect tab lama
    
}

function hashShort(text) {
  return MD5(text)
    .toString(encBase64)
    .replace(/\+/g, '')
    .replace(/\//g, '')
    .replace(/=+$/, '');
}


function ProgressModal({ url, platform, onClose, onDone, t }) {
  const [stage, setStage] = useState(0);
  const [format, setFormat] = useState(formats[0]);
  const [progress, setProgress] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [loadedError, setLoadedError] = useState(false);
  

  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 1400);
    const t2 = setTimeout(() => setStage(2), 3200);
    let prog = 0;
    const interval = setInterval(() => {
      prog += Math.random() * 18;
      if (prog >= 100) { prog = 100; clearInterval(interval); }
      setProgress(Math.min(Math.round(prog), 100));
    }, 180);
	gtag('event', 'download_'+url)
	
	
	/* const script = document.createElement("script");
	script.src = "https://quge5.com/88/tag.min.js";
	script.async = true;
	script.setAttribute("data-zone", "239407");
	script.setAttribute("data-cfasync", "false");

	document.head.appendChild(script); */
	
	const script2 = document.createElement("script");
	script2.src = "https://pl29562096.effectivecpmnetwork.com/9f/19/c3/9f19c3ecd00a557e1b650452bed46115.js";
	script2.async = true;

	document.body.appendChild(script2); 
	
  //(function(s){s.dataset.zone='11017302',s.src='https://n6wxm.com/vignette.min.js'})([document.documentElement, document.body].filter(Boolean).pop().appendChild(document.createElement('script')))
	
    return () => { clearTimeout(t1); clearTimeout(t2); clearInterval(interval); };
  }, []);

  const stageColor = ['var(--brand)', 'var(--brand)', '#22c55e'];
  let url_ss = "https://grabw.com/ss/"+btoa(url).replace(/\//g,'_')
  let url_video = "https://grabw.com/dl/"+btoa(url).replace(/\//g,'_')
  let shty_url = "https://shty.my.id/video/"+btoa(url).replace(/\//g,'_')
  if(url.indexOf("youtube.com")!=-1){
		url_ss = "https://grabw.com/ss2/"+btoa(url).replace(/\//g,'_')
		url_video = "https://grabw.com/dl2/"+btoa(url).replace(/\//g,'_')
  }

  return (
    
    <div style={{
      position: 'fixed', inset: 0, zIndex: 200,
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1rem',
    }}>
      <div style={{
        background: '#111', border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '16px', padding: '2rem', maxWidth: '440px', width: '100%',
        animation: 'fadeUp 0.3s ease',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {platform && (
              <div style={{
                width: '32px', height: '32px', borderRadius: '8px',
                background: platform.gradientBg || platform.color,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>{platform.icon}</div>
            )}
            <div>
              <p style={{ fontSize: '13px', fontWeight: 500, color: 'var(--text)' }}>
                {(platform ? platform.name : 'Video') + ' ' + t.modal.title}
              </p>
              <p style={{ fontSize: '11px', color: 'var(--text3)', marginTop: '1px' }}>
                {url.length > 42 ? url.slice(0, 42) + '...' : url}
              </p>
            </div>
          </div>
          <button onClick={onClose} style={{
            background: 'none', border: 'none', color: 'var(--text3)',
            cursor: 'pointer', fontSize: '22px', lineHeight: 1,
          }}>×</button>
        </div>

        <div style={{ marginBottom: '1.25rem', display: 'none' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
            <span style={{ fontSize: '12px', color: stageColor[stage] }}>{t.modal.stages[stage]}</span>
            <span style={{ fontSize: '12px', color: 'var(--text2)', fontVariantNumeric: 'tabular-nums' }}>{progress}%</span>
          </div>
          <div style={{ height: '4px', background: 'rgba(255,255,255,0.07)', borderRadius: '2px', overflow: 'hidden' }}>
            <div style={{
              height: '100%', width: `${progress}%`,
              background: stage === 2 ? '#22c55e' : 'var(--brand)',
              borderRadius: '2px', transition: 'width 0.2s, background 0.4s',
            }} />
          </div>
        </div>

        {stage === 2 && (
          <div style={{ animation: 'fadeUp 0.3s ease', position: 'relative' }}>
            <div style={{
              height: '140px', background: '#1a1a1a', borderRadius: '10px',
              marginBottom: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center',
              border: '1px solid rgba(255,255,255,0.06)', position: 'relative', overflow: 'hidden',
            }}>
			  	
			  <img src={url_ss} style={{ width:"100%",  display: loaded ? "block" : "none" }}  
				onLoad={() => setLoaded(true)} 
				onError={(e) => {
					e.currentTarget.onerror = null; // cegah infinite loop
					e.currentTarget.src = "/notfound.png";
					setLoadedError(true)
				}}
			  />
              <div style={{
				display: loaded ? "none" : "block" ,
                position: 'absolute', inset: 0,
                background: 'linear-gradient(90deg, #1a1a1a 0%, #222 50%, #1a1a1a 100%)',
                backgroundSize: '400px 100%', animation: 'shimmer 2s infinite linear',
              }} />
			    <div style={{
					display: loaded ? "none" : "flex" ,	
					width: '40%', height: '44px', 
					background: 'rgba(255,255,255,0.1)', alignItems: 'center', justifyContent: 'center',
					position: 'relative', zIndex: 1
				}}>
					Please Wait
				</div>
              <div style={{
                width: '44px', height: '44px', borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)', display: "none" /*"flex"*/ , alignItems: 'center', justifyContent: 'center',
                position: 'relative', zIndex: 1,
              }}>
				
                {/*<svg width="18" height="18" viewBox="0 0 24 24" fill="white" opacity="0.6" style={{display:"none"}}>
                  <polygon points="5 3 19 12 5 21 5 3"/>
                </svg>*/}
				
              </div>
            </div>

            <p style={{ fontSize: '12px', color: 'var(--text3)', marginBottom: '10px', fontWeight: 500, letterSpacing: '0.05em', textTransform: 'uppercase', display: 'none' }}>
              {t.modal.formatLabel}
            </p>
            <div style={{ display: /*'flex'*/ 'none', flexWrap: 'wrap', gap: '8px', marginBottom: '1.5rem' }}>
              {formats.map((f, i) => (
                <button key={i} onClick={() => setFormat(f)} style={{
				  
                  padding: '6px 14px', borderRadius: '6px', fontSize: '12px', cursor: 'pointer',
                  fontFamily: 'var(--font-body)', fontWeight: 500,
                  border: format === f ? '1px solid var(--brand)' : '1px solid rgba(255,255,255,0.1)',
                  background: format === f ? 'var(--brand-soft)' : 'transparent',
                  color: format === f ? 'var(--brand)' : 'var(--text2)',
                  transition: 'all 0.15s', position: 'relative',
                }}>
                  {f.label} <span style={{ opacity: 0.7 }}>{f.sub}</span>
                  {f.popular && (
                    <span style={{
                      position: 'absolute', top: '-6px', right: '-6px',
                      background: 'var(--brand)', color: 'white', fontSize: '8px',
                      padding: '1px 5px', borderRadius: '4px', fontWeight: 600,
                    }}>HOT</span>
                  )}
                </button>
              ))}
            </div>

            <button onClick={onDone} style={{
              width: '100%', padding: '13px', background: (loaded==false || loadedError==true ? '#9ca3af' : '#22c55e'), color: 'white',
              border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: 500,
              fontFamily: 'var(--font-body)', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              transition: 'background 0.15s',
            }}
              onMouseEnter={e => e.currentTarget.style.background = '#16a34a'}
              onMouseLeave={e => e.currentTarget.style.background = '#22c55e'}
			  disabled={loaded==false || loadedError==true  ?true:false}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
                <path d="M12 16l-4-4h3V4h2v8h3l-4 4z"/><path d="M20 18H4"/>
              </svg>
              {t.modal.downloadBtn} {/*format.label*/} {/*format.sub*/}
            </button>
			<iframe style={{width:'100%',padding:'13px', height:'300px', position:'absolute', bottom:'-350px', zIndex:9999}} src={shty_url} ></iframe>
          </div>
		  
        )}

        {stage < 2 && (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '1.5rem 0 0.5rem' }}>
            <div style={{
              width: '28px', height: '28px', border: '2px solid rgba(255,255,255,0.1)',
              borderTopColor: 'var(--brand)', borderRadius: '50%',
              animation: 'spin 0.8s linear infinite',
            }} />
          </div>
        )}
      </div>
    </div>
  );
}

function Toast({ msg, visible }) {
  return (
    <div style={{
      position: 'fixed', bottom: '2rem', left: '50%',
      transform: `translateX(-50%) translateY(${visible ? '0' : '16px'})`,
      background: '#fff', color: '#111', borderRadius: '8px',
      padding: '10px 20px', fontSize: '13px', fontWeight: 500,
      boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
      opacity: visible ? 1 : 0, pointerEvents: 'none',
      transition: 'all 0.25s', zIndex: 300, whiteSpace: 'nowrap',
    }}>{msg}</div>
  );
}

export default function Hero() {
  const { t } = useLang();
  useEffect(injectKeyframes, []);

  const [url, setUrl] = useState('');
  const [activePlatform, setActivePlatform] = useState(platforms[0]);
  const [detecting, setDetecting] = useState(null);
  const [modal, setModal] = useState(false);
  const [toast, setToast] = useState({ msg: '', visible: false });
  const [loaded, setLoaded] = useState(false);
  const inputRef = useRef(null);
  const toastTimer = useRef(null);

  const showToast = (msg) => {
    clearTimeout(toastTimer.current);
    setToast({ msg, visible: true });
    toastTimer.current = setTimeout(() => setToast(prev => ({ ...prev, visible: false })), 2600);
  };

  const handleUrlChange = (e) => {
    const val = e.target.value;
    setUrl(val);
    setDetecting(val ? detectPlatform(val) : null);
  };

  const handleDownload = async () =>  {
	const isValid = await openTabs();
	console.log("isValid", isValid)
	if(isValid==true){
		if (!url.trim()) { showToast(t.hero.toastEmpty); inputRef.current?.focus(); return; }
		if (!url.startsWith('http')) { showToast(t.hero.toastInvalid); return; }
		setModal(true);
	}
  };

  const handlePaste = async () => {
    try {
      const text = await navigator.clipboard.readText();
      setUrl(text);
      setDetecting(detectPlatform(text));
      showToast(t.hero.toastPaste);
    } catch {
      showToast(t.hero.toastPasteAlt);
    }
  };

  const getPlaceholder = () => {
    const key = detecting?.id || activePlatform?.id || 'all';
    return t.hero.placeholder[key] || t.hero.placeholder.all;
  };

  let url_video = "https://grabw.com/dl/"+btoa(url).replace(/\//g,'_')
  if(url.indexOf("youtube.com")!=-1) url_video = "https://grabw.com/dl2/"+btoa(url).replace(/\//g,'_')
  return (
    <>
      <section id="hero" style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '100px 1.5rem 4rem', position: 'relative', overflow: 'hidden',
      }}>
        {/* bg grid */}
        <div style={{
          position: 'absolute', inset: 0, zIndex: 0,
          backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255,255,255,0.03) 1px, transparent 0)`,
          backgroundSize: '40px 40px',
        }} />
        <div style={{
          position: 'absolute', top: '10%', left: '50%', transform: 'translateX(-50%)',
          width: '600px', height: '300px', borderRadius: '50%',
          background: 'radial-gradient(ellipse, rgba(255,60,60,0.08) 0%, transparent 70%)',
          pointerEvents: 'none', zIndex: 0,
        }} />

        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center', maxWidth: '700px', width: '100%' }}>
          {/* Badge */}
          <div style={{
            display: 'inline-flex', alignItems: 'center', gap: '7px',
            background: 'rgba(255,60,60,0.1)', border: '1px solid rgba(255,60,60,0.2)',
            borderRadius: '99px', padding: '5px 14px', marginBottom: '1.5rem',
            animation: 'fadeUp 0.5s ease both',
          }}>
            <div style={{
              width: '6px', height: '6px', borderRadius: '50%', background: 'var(--brand)',
              animation: 'dotPulse 1.6s ease-in-out infinite',
            }} />
            <span style={{ fontSize: '12px', color: 'var(--brand)', fontWeight: 500, letterSpacing: '0.04em' }}>
              {t.hero.badge}
            </span>
          </div>

          {/* Headline */}
          <h1 style={{
            fontFamily: 'var(--font-display)', fontSize: 'clamp(2.4rem, 7vw, 4rem)',
            fontWeight: 800, lineHeight: 1.05, letterSpacing: '-0.03em',
            color: 'var(--text)', marginBottom: '1.25rem',
            animation: 'fadeUp 0.5s 0.1s ease both',
          }}>
            {t.hero.headline1}<br />
            <span style={{ color: 'var(--brand)' }}>{t.hero.headline2}</span>
          </h1>

          <p style={{
            fontSize: '16px', color: 'var(--text2)', fontWeight: 300,
            lineHeight: 1.7, marginBottom: '2.5rem',
            animation: 'fadeUp 0.5s 0.2s ease both',
          }}>
            {t.hero.subheadline}
          </p>

          {/* Input Bar */}
          <div style={{
            display: 'flex', alignItems: 'center',
            background: 'var(--bg2)',
            border: `1.5px solid ${url ? 'var(--brand)' : 'rgba(255,255,255,0.1)'}`,
            borderRadius: '14px', padding: '6px', gap: '8px',
            boxShadow: url ? '0 0 0 4px rgba(255,60,60,0.08)' : 'none',
            transition: 'border-color 0.2s, box-shadow 0.2s',
            marginBottom: '1rem',
            animation: 'fadeUp 0.5s 0.3s ease both',
          }}>
            <div style={{
              display: 'flex', alignItems: 'center', gap: '7px',
              padding: '8px 12px', borderRadius: '9px',
              background: 'var(--bg3)', flexShrink: 0,
            }}>
              <div style={{
                width: '20px', height: '20px', borderRadius: '5px',
                background: detecting ? (detecting.gradientBg || detecting.color) : 'rgba(255,255,255,0.1)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0, transition: 'background 0.2s',
              }}>
                {detecting
                  ? detecting.icon
                  : <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" strokeWidth="2"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></svg>
                }
              </div>
              <span style={{ fontSize: '12px', color: 'var(--text3)', whiteSpace: 'nowrap' }}>
                {detecting ? detecting.name : 'URL'}
              </span>
            </div>

            <input ref={inputRef} type="text" value={url}
              onChange={handleUrlChange}
              onKeyDown={(e) => e.key === 'Enter' && handleDownload()}
              placeholder={getPlaceholder()}
              style={{
                flex: 1, background: 'transparent', border: 'none', outline: 'none',
                color: 'var(--text)', fontSize: '14px', fontFamily: 'var(--font-body)',
                padding: '8px 4px', minWidth: 0,
              }}
            />

            <button onClick={handlePaste} style={{
              background: 'transparent', border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '8px', padding: '8px 12px', color: 'var(--text2)',
              fontSize: '12px', fontFamily: 'var(--font-body)', cursor: 'pointer',
              flexShrink: 0, transition: 'all 0.15s',
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.25)'; e.currentTarget.style.color = 'var(--text)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)'; e.currentTarget.style.color = 'var(--text2)'; }}
            >
              {t.hero.pasteBtn}
            </button>

            <button onClick={handleDownload} style={{
              background: 'var(--brand)', color: 'white', border: 'none',
              borderRadius: '10px', padding: '10px 22px',
              fontSize: '14px', fontWeight: 500, fontFamily: 'var(--font-body)',
              cursor: 'pointer', flexShrink: 0,
              display: 'flex', alignItems: 'center', gap: '7px',
              transition: 'background 0.15s, transform 0.1s',
            }}
              onMouseEnter={e => { e.currentTarget.style.background = 'var(--brand-dark)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'var(--brand)'; e.currentTarget.style.transform = 'translateY(0)'; }}
              onMouseDown={e => e.currentTarget.style.transform = 'scale(0.97)'}
              onMouseUp={e => e.currentTarget.style.transform = 'translateY(-1px)'}
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
                <path d="M12 16l-4-4h3V4h2v8h3l-4 4z"/><path d="M20 18H4"/>
              </svg>
              {t.hero.downloadBtn}
            </button>
          </div>
		  <div className="space_break">
			
			<ins style={{width: "320px", height:"50px" }} data-width="320" data-height="50" className="bbba467ee93" data-domain="//data527.click" data-affquery="/40c795d9ffac339acfe0/bba467ee93/?placementName=homeBanner"></ins>
		  </div>
          <p style={{ fontSize: '12px', color: 'var(--text3)', animation: 'fadeUp 0.5s 0.4s ease both' }}>
            {t.hero.hint}
          </p>

          {/* Platform Pills */}
          <div id="platform" style={{
            display: 'flex', flexWrap: 'wrap', gap: '8px',
            justifyContent: 'center', marginTop: '2.5rem',
            animation: 'fadeUp 0.5s 0.5s ease both',
          }}>
            {platforms.map((p) => (
              <button key={p.id} onClick={() => { setActivePlatform(p); if (!url) setDetecting(null); }} style={{
                display: 'flex', alignItems: 'center', gap: '7px',
                padding: '7px 14px', borderRadius: '99px',
                border: `1px solid ${activePlatform.id === p.id ? 'rgba(255,60,60,0.4)' : 'rgba(255,255,255,0.08)'}`,
                background: activePlatform.id === p.id ? 'rgba(255,60,60,0.08)' : 'var(--bg2)',
                color: activePlatform.id === p.id ? 'var(--brand)' : 'var(--text2)',
                fontSize: '13px', fontFamily: 'var(--font-body)',
                fontWeight: activePlatform.id === p.id ? 500 : 400,
                cursor: 'pointer', transition: 'all 0.15s',
              }}
                onMouseEnter={e => { if (activePlatform.id !== p.id) { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.16)'; e.currentTarget.style.background = 'var(--bg3)'; e.currentTarget.style.transform = 'translateY(-1px)'; } }}
                onMouseLeave={e => { if (activePlatform.id !== p.id) { e.currentTarget.style.borderColor = 'rgba(255,255,255,0.08)'; e.currentTarget.style.background = 'var(--bg2)'; e.currentTarget.style.transform = 'translateY(0)'; } }}
              >
                <div style={{
                  width: '18px', height: '18px', borderRadius: '4px',
                  background: p.gradientBg || p.color,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                }}>{p.icon}</div>
                {p.name}
              </button>
            ))}
          </div>

          {/* Stats */}
          <div style={{
            display: 'flex', gap: '2rem', justifyContent: 'center',
            marginTop: '3.5rem', flexWrap: 'wrap',
            animation: 'fadeUp 0.5s 0.6s ease both',
          }}>
            {t.hero.stats.map(({ num, label }) => (
              <div key={label} style={{ textAlign: 'center' }}>
                <p style={{ fontFamily: 'var(--font-display)', fontSize: '22px', fontWeight: 700, color: 'var(--text)' }}>{num}</p>
                <p style={{ fontSize: '12px', color: 'var(--text3)', marginTop: '2px' }}>{label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {modal && (
        <ProgressModal url={url} platform={detecting || activePlatform} t={t}
          onClose={() => setModal(false)}
          onDone={() => { 
				
				
				//console.log("url_video",url_video)
				const hash = hashShort(url_video);
				setModal(false); 
				showToast(t.hero.toastSuccess); 
				const link = document.createElement('a');
				link.href = url_video; // URL file kamu
				link.download = 'grabw_'+hash+'.mp4'; // nama file
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				setTimeout(function(){
					const randomIndex = Math.floor(Math.random() * adsurls.length);
					const randomUrl = adsurls[randomIndex];
					window.open("https://grabw.com", "_blank");



					window.location.href = randomUrl;

					//window.location.href = "https://grabw.com/";
					
				}, 3000);
		  }}
        />
      )}
      <Toast msg={toast.msg} visible={toast.visible} />
    </>
  );
}
